export default "/images/space-plan-wizard-logo.svg";